export function LogoMark({ size = 40, dark = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path d="M8 24 L24 10 L40 24" stroke={dark ? "#FFFFFF" : "#13224A"} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 35 H33" stroke="#1FBF8F" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ dark = false, tagline = false, size = 36, className = "" }) {
  return (
    <span className={`inline-flex flex-col ${className}`} data-testid="imodesk-logo">
      <span className="inline-flex items-center gap-2.5">
        <LogoMark size={size} dark={dark} />
        <span className="font-body font-extrabold tracking-tight leading-none" style={{ fontSize: size * 0.72 }}>
          <span style={{ color: dark ? "#FFFFFF" : "#13224A" }}>Imo</span><span style={{ color: "#1FBF8F" }}>Desk</span>
        </span>
      </span>
      {tagline && <span className={`block text-xs mt-1.5 ${dark ? "text-white/60" : "text-slate-500"}`} style={{ paddingLeft: size + 10 }}>Da angariação à escritura</span>}
    </span>
  );
}
